
import './checkbox.css';
import { MdError } from "react-icons/md";

function Checkbox({isChecked, setIsChecked}) {



    const renderClass = isChecked ? "checkboxinactivetrue" : "checkboxinactive"
    return (
        <>
            <label>
                <input
                    type="checkbox"
                    onChange={() => {
                        setIsChecked(!isChecked);
                    }}
                />
                <span
                    className={`checkbox ${isChecked ? "checkbox--active" : "checkbox--inactive"}`}
                    aria-hidden="true"
                >
                    <div className='divspancheckbox'>
                        <svg viewBox="0 0 12 10" className="svgcheckbox svgstyles">
                            <polyline points="1.5 6 4.5 9 10.5 1"></polyline>
                        </svg>
                    </div>
                </span>
                <span className='textspan'>
                    Aceito receber informações pelos canais de relacionamento (SMS, telefone, WhatsApp e email)
                </span>
            </label>
            <div className={renderClass}>
                <MdError
                className='svgerror'/>
                <div className='spacechinactive'></div>
                <p className='textchinactive'>Você precisa aceitar para continuar</p>
            </div>
        </>
    );
}

export default Checkbox;